import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { UserRoleResource } from '../resource/user-role.resource';
import { Role } from '../ui/role.model';

export class RoleToUserRoleResourceMapper extends MapperBase<Role, UserRoleResource> {
	map(source: Role): UserRoleResource {
		const dest = {} as UserRoleResource;
		dest.id = Guid.Empty;
		dest.name = source?.name ?? '';
		return dest;
	}

}
